import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CircleIcon from '@mui/icons-material/Circle';
import UploadDocumentButtonOnboarding from '../buttons/UploadDocumentButtonOnboarding';
import { HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME, SECONDARY_STACK_CLASS_NAME } from '../../theme/constants/stack';
import { useGetInvoice } from '../../hooks';
import { INVOICE_REQUIREMENTS_DOCUMENTS } from '../../graphql';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const RestrictionItemWithDocumentUpload = ({ detail, isMobile, invoiceId }) => {
  const invoice = useGetInvoice(invoiceId, INVOICE_REQUIREMENTS_DOCUMENTS);
  return (
    <Stack
      className={SECONDARY_STACK_CLASS_NAME}
      p={1}
      sx={{ borderRadius: '15px', minHeight: { xs: '40px', md: '50px' }, p: { xs: 0.5, md: 1 } }}
      alignContent="center"
      justifyContent="center"
    >
      <Stack direction="row" alignItems="center">
        <Box
          sx={{ width: '5%' }}
          display="flex"
          alignItems="center"
          justifyContent="center"

        >
          <CircleIcon
            className={DEFAULT_ICON_CLASS_NAME}
            sx={{
              height: isMobile ? 10 : 15,
              width: isMobile ? 10 : 15,

            }}
          />
        </Box>
        <Box
          sx={{
            width: '95%',
            paddingLeft: '3px',
          }}
          display="flex"
          alignItems="center"
        >
          <Typography variant={isMobile ? 'small_2' : 'medium_1'} fontWeight="500">
            {detail.restrictionLabel}
          </Typography>
        </Box>
        <UploadDocumentButtonOnboarding
          invoiceId={invoiceId}
          invoiceDocuments={invoice?.documents || []}
          documentType={detail.documentInfo?.documentType}
          accept={detail.documentInfo?.accept}
          errorMessage={detail.documentInfo?.errorMessage}
          boxProps={{
            sx: {
              width: 400,
            },
          }}
          className={HIGHLIGHTED_UPLOAD_DOCUMENT_STACK_CLASS_NAME}
        />
      </Stack>
    </Stack>
  );
};

RestrictionItemWithDocumentUpload.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    restrictionLabel: PropTypes.string,
    description: PropTypes.string,
    status: PropTypes.string,
    statusLabel: PropTypes.string,
    documentInfo: PropTypes.shape({
      documentType: PropTypes.string,
      accept: PropTypes.string,
      errorMessage: PropTypes.string,
    }),
  }),
  isMobile: PropTypes.bool.isRequired,
  invoiceId: PropTypes.string,
};

RestrictionItemWithDocumentUpload.defaultProps = {
  detail: {},
  invoiceId: null,
};

export default RestrictionItemWithDocumentUpload;
